import React from 'react';

import { AuthInfo } from '@search/auth/src/AuthInfo';
import { useM2AuthContext } from '@search/auth/src/M2AuthProvider';
import { useUserDetailsFetcher } from '@search/auth/src/userDetails/userDetails';
import { UseAuthError } from '@search/auth/src/useAuth';
import { minimalBanksMortgageUrlCreate } from './minimalBanksMortgageUrl';
import { windowOpen } from './mortgage2/useMortgage2Request';
import { useMortgageAppSource } from './MortgageAppSourceContext';

const openOrAuth = (authInfo?: AuthInfo) => {
    return new Promise((resolve, reject) => {
        if (authInfo?.isAuthenticated) {
            resolve(null);
        } else {
            reject();
        }
    });
};

export const useMortgagePage = (isMobile?: boolean) => {
    const userDetailsFetcher = useUserDetailsFetcher();
    const { waitAuth } = useM2AuthContext();
    const sourceMortgage = useMortgageAppSource();

    const openLink = () => {
        waitAuth(
            authInfo => openOrAuth(authInfo)
                .then(() => userDetailsFetcher())
                .catch((e) => {
                    throw new UseAuthError();
                }),
            { continueAfterLogin: true }
        )
            .then((userDetails) => {
                const { fullUrl: minimalBanksMortgageUrl } = minimalBanksMortgageUrlCreate({
                    isAuthenticated: true,
                    mobilePhone: userDetails.data?.userDetails?.phone ?? '',
                    fio: userDetails.data?.userDetails?.username ?? '',
                    source: sourceMortgage
                });

                windowOpen(minimalBanksMortgageUrl, { isMobile });
            })
            // eslint-disable-next-line no-console
            .catch(e => console.error(e));
    };

    return {
        openLink
    };
};
